<template>
  <div class="container" style="padding-left: 0px;padding-right: 0px">
    <div class="row">
      <div class="col-md-12">


        <div class="card" style="" v-if="datas!==null">
          <img :src="datas.data.couponDisplayUrl" class="card-img-top" alt="...">



          <div class="card-body">
            <div class="content">
              <div class="date" style="float:left">有效日期 : {{datas.data.expiredDate}}</div>
              <div class="" style="float:right;" v-if="!datas.data.isGetUnLimit">剩餘組數 : <span style="color:#E85325">{{datas.data.getCouponLimit-datas.data.getCouponCount}} </span></div>
              <div style="display: block;padding-top:30px">
              <h2 class="coupon-name">
                {{datas.data.title}}
              </h2>
                <div v-if="flag.showBlock_barCode">
                  <div class="qr" v-if="datas.data.qrCodeUrl">
                    <img :src="datas.data.qrCodeUrl" class="card-img-top" alt="...">
                  </div>
                  <div class="barcode" v-if="datas.data.couponSerialNo">
                    <img :src="datas.data.barCodeUrl" class="card-img-top" alt="...">
                    <div class="barcode-nu">票券編號：{{datas.data.couponSerialNo}}</div>
                  </div>

                </div>
                <div v-if="flag.showBlock_serialCode">
                  <div class="coupon-code">
                    <div class="serial">
                      <div class="serial-nu">優惠序號</div>
                      <div class="serial-nu1" id="mySN">{{datas.data.couponSerialNo}}</div>

                    </div>
                    <div class="copySN" @click="copySN">{{ buttonSerialCodeText }}</div>
                  </div>
                </div>

              <div class="desc">
                <div class="sub-title">活動說明：</div>
                <div id="description" style="word-break: break-all;">
                  <span v-html="datas.data.description"></span>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <br>
        <br>
        <br>
        <br>
        <br>
    </div>

    <div class="fixed-bottom" v-if="flag.showBottomBar">
      <div v-if="flag.bottomBarEnable">
        <button class="btn  w-100 bottomBar_Enable"  @click="BottomBar_click">{{ flag.bottomBarText }}</button>
<!--        <div v-if="flag.showDialogType1">-->
<!--          <button class="btn  w-100 bottomBar_Enable" data-toggle="modal" data-target="#confirmModal1" @click="BottomBar_click">{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
<!--        <div v-if="flag.showDialogType2">-->
<!--          <button class="btn  w-100 bottomBar_Enable" data-toggle="modal" data-target="#confirmModal2" @click="BottomBar_click">{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
<!--        <div v-if="!flag.showDialogType1 && !flag.showDialogType2">-->
<!--          <button class="btn  w-100 bottomBar_Enable" >{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
      </div>
      <div v-else>
        <button class="btn  w-100 bottomBar_Disable" @click="BottomBar_click">{{ flag.bottomBarText }}</button>

<!--        <div v-if="flag.showDialogType1">-->
<!--          <button class="btn  w-100 bottomBar_Disable" data-toggle="modal" data-target="#confirmModal1" @click="BottomBar_click">{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
<!--        <div v-if="flag.showDialogType2">-->
<!--          <button class="btn  w-100 bottomBar_Disable" data-toggle="modal" data-target="#confirmModal2" @click="BottomBar_click">{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
<!--        <div v-if="!flag.showDialogType1 && !flag.showDialogType2">-->
<!--          <button class="btn  w-100 bottomBar_Disable" >{{ flag.bottomBarText }}</button>-->
<!--        </div>-->
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="confirmModal1" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border-0" style="width: 70%;margin: auto;">
          <div class="modal-header border-0 centered-title">
            <h5 class="modal-title" id="confirmModalLabel">您獲得優惠券</h5>
          </div>
          <div class="modal-body">
            前往兌換此優惠券，或選擇繼續領取優惠券。
          </div>
          <div class="modal-footer border-0 justify-content-between">
            <button type="button" class="btn btn-secondary btn-lg" @click="dialogType1_Button1" data-dismiss="modal">前往兌換</button>
            <button type="button" class="btn btn-primary btn-lg" @click="dialogType1_Button2" data-dismiss="modal">繼續領取</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
      <div class="modal fade" id="confirmModal2" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content border-0" style="width: 70%;margin: auto;">
            <div class="modal-header border-0 centered-title">
              <h5 class="modal-title" id="confirmModalLabel">確認是否兌換</h5>
            </div>
            <div class="modal-body">
              點選使用即可完成優惠券兌換，優惠內容請詳閱活動說明。
            </div>
            <div class="modal-footer border-0 justify-content-between">
              <button type="button" class="btn btn-secondary btn-lg" @click="dialogType2_Button1" data-dismiss="modal">返回</button>
              <button type="button" class="btn btn-primary btn-lg" @click="dialogType2_Button2" data-dismiss="modal">使用</button>
            </div>
          </div>
        </div>
      </div>


  </div>
  </div>
</template>
<script>
import apiCoupon from "@/js/apiCoupon";
import {CKey, readFromStorage} from "@/js/storage";
import util from "@/js/util";

export default {
  data() {
    return {
      couponSID:"",
      datas: null,
      C:"",    //由App帶過來的Token,要經過Api的解密，可以得到 Sid等資訊
      mode:"list",  //list,my
      flag:{
        showBlock_barCode:false,
        showBlock_serialCode:false,
        showBottomBar:false,
        bottomBarEnable:false,
        bottomBarText:"領取優惠",
        bottomBarClickActionType:"",
        showDialogType1:false,  //前往兌換，繼續領取
        showDialogType2:false,  //返回，使用
      },
      buttonSerialCodeText:"點此複製序號",
      buttonSerialCodeTextOrg:"點此複製序號",
      couponSerialNoButtonText:"",
      couponSerialNoUrl:"",
    }
  },
  components: {
  },
  methods: {
    changeUI(){
      const useMethod=this.datas.data.useMethod;
      const isUsed=this.datas.data.isUsed;
      this.couponSerialNoButtonText=this.datas.data.couponSerialNoButtonText;
      this.couponSerialNoUrl=this.datas.data.couponSerialNoUrl;

      //可參考文件 優惠券-開發文件.docx
      if (useMethod==="CLICK_USE"){
        if (this.mode==="list"){
          if (isUsed){
            //不應該到此  //QQ
            alert('case else');
          }else{
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=true;
            this.flag.bottomBarEnable=true;
            this.flag.bottomBarText="領取優惠";
            this.flag.bottomBarClickActionType="getCoupon";
            this.flag.showDialogType1=true;
            this.flag.showDialogType2=false;
          }
        }else if (this.mode==="my"){
          if (isUsed){
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=true;
            this.flag.bottomBarEnable=false;
            this.flag.bottomBarText="已使用";
            this.flag.bottomBarClickActionType="";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=false;
          }else{
            this.flag.showBlock_barCode=false;
            this.flag.showBottomBar=true;
            this.flag.bottomBarEnable=true;
            this.flag.bottomBarText="立即兌換優惠券";
            this.flag.bottomBarClickActionType="useCoupon";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=true;
          }
        }else{
          alert("不正確的mode" + this.mode);
        }
      }else if (useMethod==="QRCODE_BARCODE_USE"){
        if (this.mode==="list"){
          if (isUsed){
            //不應該到此  //QQ
            alert('case else');
          }else{
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=true;
            this.flag.bottomBarEnable=true;
            this.flag.bottomBarText="領取優惠";
            this.flag.bottomBarClickActionType="getCoupon";
            this.flag.showDialogType1=true;
            this.flag.showDialogType2=false;
          }
        }else if (this.mode==="my"){
          if (isUsed){
            this.flag.showBlock_barCode=true;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=false;
            this.flag.bottomBarEnable=false;
            this.flag.bottomBarText="";
            this.flag.bottomBarClickActionType="";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=false;
          }else{
            this.flag.showBlock_barCode=true;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=false;
            this.flag.bottomBarEnable=false;
            this.flag.bottomBarText="";
            this.flag.bottomBarClickActionType="";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=false;
          }
        }else{
          alert("不正確的mode" + this.mode);
        }
      }else if (useMethod==="COUPOUN_USE") {
        if (this.mode==="list"){
          if (isUsed){
            //不應該到此  //QQ
            alert('case else');
          }else{
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=false;
            this.flag.showBottomBar=true;
            this.flag.bottomBarEnable=true;
            this.flag.bottomBarText="領取優惠";
            this.flag.bottomBarClickActionType="getCoupon";
            this.flag.showDialogType1=true;
            this.flag.showDialogType2=false;
          }
        }else if (this.mode==="my"){
          if (isUsed){
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=true;
            this.flag.showBottomBar=false;
            this.flag.bottomBarEnable=false;
            this.flag.bottomBarText="";
            this.flag.bottomBarClickActionType="";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=false;
          }else{
            this.flag.showBlock_barCode=false;
            this.flag.showBlock_serialCode=true;
            this.flag.showBottomBar=false;
            this.flag.bottomBarEnable=false;
            this.flag.bottomBarText="";
            this.flag.bottomBarClickActionType="";
            this.flag.showDialogType1=false;
            this.flag.showDialogType2=false;
          }

          if (this.couponSerialNoButtonText && this.couponSerialNoUrl){
            this.buttonSerialCodeText=this.couponSerialNoButtonText;
          }else{
            this.buttonSerialCodeText=this.buttonSerialCodeTextOrg;
          }
        }else{
          alert("不正確的mode" + this.mode);
        }
      }else if (useMethod === undefined){
        //代表沒有領取資格
      }else{
        alert('不正確的useMethod' + useMethod);
      }
    },
    dialogType1_Button1(){
      //前往兌換
      this.mode="my";
      this.loadData(this.couponSID);
      this.changeUI();
    },
    dialogType1_Button2(){
      //繼續領取
      this.$router.push({ name: 'CouponList'})
    },
    dialogType2_Button1(){
      //返回
      this.hideDialog();
    },
    dialogType2_Button2(){
      //使用
      //this.mode="my";
      apiCoupon.api_useCoupon2(this.C,this.couponSID).then((data)=>{
        if (this.handleStatus(data)){
          util.ShowMessage("已使用成功!!")
          this.loadData(this.couponSID);
          this.changeUI();
        }
      })
    },
    BottomBar_click(){
      if (this.flag.bottomBarClickActionType==="getCoupon"){
        apiCoupon.api_getCoupon(this.C,this.couponSID).then((data)=>{
          if (this.handleStatus(data)){
            this.showDialog();
          }
        })
      }else if (this.flag.bottomBarClickActionType==="useCoupon"){
        this.showDialog();
      }else{
        //沒有Api動作
        this.showDialog();
      }
    },
    showDialog(){
      if (this.flag.showDialogType1) {
        $('#confirmModal1').modal('show');  // eslint-disable-line
      }
      if (this.flag.showDialogType2){
        $('#confirmModal2').modal('show');  // eslint-disable-line
      }
    },
    hideDialog(){
      if (this.flag.showDialogType1) {
        $('#confirmModal1').modal('hide');  // eslint-disable-line
      }
      if (this.flag.showDialogType2){
        $('#confirmModal2').modal('hide');  // eslint-disable-line
      }
    },
    copySN(){
      let bGotoUrl=this.couponSerialNoButtonText && this.couponSerialNoUrl;

      navigator.clipboard.writeText(this.datas.data.couponSerialNo)
          .then(() => {
            if (!bGotoUrl){//會複製，但不要顯示複製成功
              util.ShowMessage("已複製序號");
            }
          })
          .catch(err => { // eslint-disable-line
            util.ShowMessage("複製序號  失敗");
          });

      if (bGotoUrl){
        window.location.href=this.couponSerialNoUrl + this.datas.data.couponSerialNo;
      }

    },
    gotoList(){
      this.$router.push({ name: 'CouponList'})
    },
    async loadData(couponSid) {
      let that=this;

      apiCoupon.api_getCouponDetail2(this.C,couponSid).then((data)=>{
        that.datas=apiCoupon.handleStatus(data);
        that.changeUI();
      })
    },
    // getCoupon(couponSid){
    //   // let that=this;
    //   apiCoupon.api_getCoupon(this.C,couponSid).then((data)=>{
    //     apiCoupon.handleStatus(data);
    //     // that.changeUI();
    //   })
    // },
    // useCoupon(couponSid,userCouponSID){
    //   // let that=this;
    //   apiCoupon.api_useCoupon(this.C,couponSid,userCouponSID).then((data)=>{
    //     apiCoupon.handleStatus(data);
    //     // that.changeUI();
    //   })
    // },
    handleStatus(data){
      let apiData=data.data;
      if (apiData.status && apiData.status==="ok"){
        return true;
      }else{
        if (apiData.message){
          util.ShowMessage(apiData.message);
          this.goBack();
        }
        return false;
      }
    },
    goBack() {
      window.history.back();
    },
  },
  mounted() {
    this.C=readFromStorage(CKey);
    this.couponSID=this.$route.query.couponSID;
    this.mode=this.$route.query.mode;
    this.loadData(this.couponSID);
  }
}
</script>
<style>
.bottomBar_Enable{
  color:white;
  background-color: #e65430;
}
.bottomBar_Disable{
  color:white;
  background-color: black;
}

.centered-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.coupon-code .serial {
  width:314px;
  background-color:#FFFFFF;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  margin:0 auto 15px auto;
  border: 8px solid #E4E4E4;
}
.serial-nu{
  display: flex;
  justify-content: center; /* 水平置中 */
  align-items: center; /* 垂直置中 */
  font-size:20pt;
  background-color: #E4E4E4;
  line-height: 50px; /* 统一行高 */
}
.coupon-code .serial-nu1{
  display: flex;
  justify-content: center; /* 水平置中 */
  align-items: center; /* 垂直置中 */
  font-size:20px;
  color:#E85325;
  line-height: 60px; /* 统一行高 */
}
.coupon-code .copySN {
  width:204px;
  background-color:#E9582B;
  color:#FFF;
  text-align:center;
  margin-top: 0;
  margin-right: auto;
  margin-bottom: 0;
  margin-left: auto;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  border-radius: 6px;
  cursor: pointer;
}
.coupon-code .copySN a{ color:#FFF;}
.qr{
  width: 196px;
  height: 196px;
  background-color: #FFFFFF;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  margin: 0 auto 15px auto;
  border: 8px solid #E4E4E4;
}
.qr img {
  vertical-align: middle;
}
</style>
